import BaseIcon from "../components/svg_icons/BaseIcon";
import { CURRENCY_SYMBOLS } from "../constants/currency";

export const formatMoney = (value) => {
    return (
        <>
            <BaseIcon name="rupeesSymbol" />
            {value ? parseFloat(value).toLocaleString("en-IN") : 0}
        </>
    );
};

export const formatMoneyWithCurrency = (amount, currency) => {
    const symbol = CURRENCY_SYMBOLS[currency?.toUpperCase()] || "";
    if (amount == null) return symbol;
    return `${symbol} ${new Intl.NumberFormat().format(amount)}`;
};

export const formatDate = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric", month: "short", year: "numeric",
    });
};

export const formatDateTime = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const formatPlatformName = (platform) => {
    const platforms = {
        whatsapp: "WhatsApp",
        email:    "Email",
        sms:      "SMS",
        platform: "Platform",
        web:      "Web",
    };
    return platforms[platform] || platform;
};
